import { useEffect, useState } from 'react';
import { renderToString } from 'react-dom/server';

import './Table.css';

function mapIndexes(n, fn) {
    let arr = [];
    for(let i = 0; i < n; i++) {
        arr.push(fn(i));
    }
    return arr;
}

function mapRange(arr, start, end, fn) {
    let mapped = [];
    mapped.length = end - start;

    for(let i = start; i < end; i++) {
        mapped.push(fn(arr[i], i));
    }

    return mapped;
}

const START_PAGING_AFTER_LENGTH = 10;
const ITEMS_PER_PAGE = 10;

function Table({ columnNames, columnRenderers, columnSorters = [], data: rawData, style = {}, showSearch = true }) {
    const [dontPage, setDontPage] = useState(false);
    const [page, setPage] = useState(0);
    const [sortingColumn, setSortingColumn] = useState(null);
    const [sortingReversed, setSortingReversed] = useState(false);

    const [search, setSearch] = useState('');

    const data = (search && showSearch) ? rawData.filter(row => {
        const lowercaseSearch = search.toLowerCase();
        for(let i = 0; i < columnNames.length; i++) {
            let val = renderToString(columnRenderers[i](row));
            if(val.toString().toLowerCase().includes(lowercaseSearch)) {
                return true;
            }
        }
        return false;
    }) : rawData;

    console.log(data);

    const dataLength = data ? data.length : 0;
    const canPage = data && dataLength > START_PAGING_AFTER_LENGTH;
    const currentlyPaging = canPage && !dontPage;
    const numPages = Math.ceil(dataLength / ITEMS_PER_PAGE);

    const nearbyPages = [page - 2, page - 1, page, page + 1, page + 2].filter(p => p >= 0 && p < numPages);
    // How many padding pages to add to center the current page
    const firstPadding = Math.max(0, 2 - page);
    const lastPadding = Math.max(0, 2 - (numPages - 1 - page));

    const sortedData = sortingColumn !== null ? [...data].sort((a, b) => {
        let res = columnSorters[sortingColumn](a, b);
        return sortingReversed ? -res : res;
    }) : data;

    useEffect(() => {
        if(page * ITEMS_PER_PAGE >= dataLength) {
            setPage(0);
        }
    }, [data]);

    const togglePaging = () => {
        setDontPage((dontPage) => !dontPage);
    }

    const firstPage = () => {
        setPage(0);
    }

    const lastPage = () => {
        setPage(numPages - 1);
    }

    const nextPage = () => {
        setPage(Math.min(page + 1, numPages - 1));
    }

    const prevPage = () => {
        setPage(Math.max(page - 1, 0));
    }

    const mapPaged = (fn) => {
        if(currentlyPaging) {
            return mapRange(sortedData, page * ITEMS_PER_PAGE, Math.min(dataLength, (page + 1) * ITEMS_PER_PAGE), fn);
        } else {
            return sortedData.map(fn);
        }
    }

    const sortBy = (i)  => {
        if(i == sortingColumn) {
            if(sortingReversed) {
                setSortingColumn(null);
                setSortingReversed(false);
            } else {
                setSortingReversed(!sortingReversed);
            }
        } else {
            setSortingColumn(i);
            setSortingReversed(false);
        }
    };



    return (
        <div className="data-table column g8" style={{ width: '100%', overflowX: 'hidden' }}>
            <div className="row g8" style={{'justifyContent': 'flex-end'}}>
                <input type="text" placeholder="Otsi..." value={search} onChange={e => setSearch(e.target.value)} style={{ maxWidth: '256px', width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ccc' }} />
            </div>
            <div style={{ width: '100%', paddingBottom: 16 }}>
                <div className='table-wrapper' style={{ width: '100%', overflowX: 'scroll' }}>
                    <table style={{ ...style, width: 'max-content', minWidth: '100%' }}>
                        <thead>
                            <tr>
                                { columnNames.map(
                                    (item, i) => (columnSorters && columnSorters[i]) ? (
                                        <th onClick={() => sortBy(i)} style={sortingColumn == i ? {backgroundColor: "#d8d8d8"} : {}}>{item} {
                                            sortingColumn == i ? (
                                                sortingReversed ? '▲' : '▼'
                                            ) : (
                                                <span style={{color: "#aaa"}}>▼</span>
                                            )
                                        }</th>
                                    ) : (
                                        <th>{item}</th>
                                    )
                                ) }
                            </tr>
                        </thead>
                        <tbody>
                            { dataLength ? mapPaged(
                                row => (
                                    <tr>
                                        { mapIndexes(columnNames.length, (i) => {
                                            return (
                                                <td>
                                                    { columnRenderers[i](row) }
                                                </td>
                                            );
                                        }) }
                                    </tr>
                                )
                            ) : (
                                <tr>
                                    <td align='center' colSpan={columnNames.length}>
                                        <p style={{ color: '#888' }}>{(showSearch && search) ? "0 tulemust" : "Sisu puudub"}</p>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                <div className="navbar row g8 center-cross">
                    { canPage && (
                        <button className='small-round' onClick={togglePaging}>{dontPage ? 'Kuva lehtedena' : 'Kuva kõik'}</button>
                    ) }

                    { currentlyPaging && (
                        <p className='p8' style={{ color: '#444', textAlign: 'center' }}>Leht {page + 1} / {numPages}-st (kokku {dataLength} rida)</p>
                    ) }

                    <div className='grow'></div>

                    { currentlyPaging ? ( <>
                        <button style={{ color: '#444' }} className='table-scroll-button noselect' onClick={firstPage}><svg width="12" height="12" viewBox="0 0 24 24"><line x1="18" y1="4" x2="6" y2="12" stroke="#888" stroke-width="2" /><line x1="18" y1="20" x2="6" y2="12" stroke="#888" stroke-width="2" /><line x1="4" y1="0" x2="4" y2="24" stroke="#888" stroke-width="2" /></svg></button>
                        <button style={{ color: '#444' }} className='table-scroll-button noselect' onClick={prevPage}><svg width="12" height="12" viewBox="0 0 24 24"><line x1="18" y1="4" x2="6" y2="12" stroke="#888" stroke-width="2" /><line x1="18" y1="20" x2="6" y2="12" stroke="#888" stroke-width="2" /></svg></button>

                        { mapIndexes(firstPadding, i => (
                            <div style={{ width: 24 }}></div>
                        )) }
                        { nearbyPages.map(p => (
                            <button style={{ width: 24, color: '#444', backgroundColor: (page == p) ? '#e8e8e8' : 'transparent', borderRadius: 4 }} className='table-scroll-button noselect' onClick={() => setPage(p)}>{p + 1}</button>
                        )) }
                        { mapIndexes(lastPadding, i => (
                            <div style={{ width: 24 }}></div>
                        )) }

                        <button className='table-scroll-button noselect' onClick={nextPage}><svg width="12" height="12" viewBox="0 0 24 24"><line x1="6" y1="4" x2="18" y2="12" stroke="#888" stroke-width="2" /><line x1="6" y1="20" x2="18" y2="12" stroke="#888" stroke-width="2" /></svg></button>
                        <button style={{ color: '#444' }} className='table-scroll-button noselect' onClick={lastPage}><svg width="12" height="12" viewBox="0 0 24 24"><line x1="6" y1="4" x2="18" y2="12" stroke="#888" stroke-width="2" /><line x1="6" y1="20" x2="18" y2="12" stroke="#888" stroke-width="2" /><line x1="20" y1="0" x2="20" y2="24" stroke="#888" stroke-width="2" /></svg></button>

                    </> ) : ( <>
                        <p className='p8' style={{ color: '#444', textAlign: 'center' }}>{dataLength} rida</p>
                    </> ) }
                </div>
            </div>
        </div>
    );
};

export const SORTER_NUMERICAL = (left, right) => {
    return left - right;
}

export const SORTER_STRING = (left, right) => {
    if (!left) return -1;
    if (!right) return +1;
    return left.localeCompare(right);
}

export default Table;